// IntersectionObserver polyfill (Safari, IE)
exports.onClientEntry = async () => {
    if (typeof IntersectionObserver === `undefined`) {
        await import(`intersection-observer`);
    }
};

// exports.onRouteUpdate = ({ location, prevLocation }) => {
//     console.log('onRouteUpdate', location, prevLocation);
//     // Vérifie si le script de tracking est chargé et window.spdt est disponible
//     if (window.spdt && prevLocation) {
//         window.spdt('view');
//     }
// };